/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationCancelEnrollmentRequestViewModel } from "../types/CourseRegistrationCancelEnrollmentRequestViewModel.ts";

export const courseRegistrationCancelEnrollmentRequestViewModelSchema =
  z.object({
    courseRegistrationId: z.optional(
      z.number().int().describe("ID da matrícula a ser cancelada."),
    ),
    statusReasonId: z
      .number()
      .int()
      .describe("ID do motivo do status de cancelamento. Opcional.")
      .nullish(),
    subStatusReasonId: z
      .number()
      .int()
      .describe("ID do sub-motivo do status de cancelamento. Opcional.")
      .nullish(),
    observation: z
      .string()
      .describe(
        "Observação registrada junto ao cancelamento da matrícula. Opcional.",
      )
      .nullish(),
  }) as unknown as ToZod<CourseRegistrationCancelEnrollmentRequestViewModel>;
